const initState = {
    services: [],
    countries: [],
    isLeavingRequestAccess: false,
};

const SET_SERVICES = 'SET_SERVICES';
const SET_COUNTRIES = 'SET_COUNTRIES';
const LEAVING_REQUEST_ACCESS = 'LEAVING_REQUEST_ACCESS';

export const setServices = (data) => ({ type: SET_SERVICES, payload: data });
export const setCountries = (data) => ({ type: SET_COUNTRIES, payload: data });
export const setIsLeavingRequestAccess = (data) => ({
    type: LEAVING_REQUEST_ACCESS,
    payload: data,
});

export default (state = initState, action) => {
    switch (action.type) {
        case SET_SERVICES:
            return { ...state, services: action.payload };
        case SET_COUNTRIES:
            return { ...state, countries: action.payload };
        case LEAVING_REQUEST_ACCESS:
            return { ...state, isLeavingRequestAccess: action.payload };
        default:
            return state;
    }
};
